module.exports = __webpack_public_path__ + "img/アルファロメオ.83a50539.png";